import { Injectable, Inject } from '@angular/core';
import { ENV_CONFIG } from 'src/app/core/injection.token';
import { ApiService } from 'src/app/core/services/api.service';

@Injectable()
export class MenuAPIService {
  public constructor(
    @Inject(ApiService) private _apiService: ApiService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData
  ) {}

  private readonly controller = 'menu';

  public GetSidebarMenuItems() {
    const request = 'getSidebarMenuItems';
    const url = this._apiService.buildUrl(this._envConfig.TENANT_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.SidebarMenuItems[]>(url);
  }
}
